import styled from "styled-components";

export const Container = styled.div`
  background: #fff;
  width: 100vw;
  min-height: 85vh;
  position: relative;
  .header {
    width: 90%;
    margin: 1rem auto;
    h1 {
      font-size: clamp(25px, 4vw, 24px);
    }
    .chart-options_container {
      display: flex;
      border-bottom: 1px solid lightGray;
      margin: 2rem 0;
      .chart-option {
        width: 100%;
        button {
          width: 100%;
          height: 50px;
          background: white;
          box-shadow: none;
          border: none;
          cursor: pointer;
          color: #000;
          font-size: 18px;
          font-weight: 700;
        }
        &.active {
          border-top: 5px solid orange;
          border-left: 1px solid lightGray;
          border-right: 1px solid lightGray;
        }
      }
    }
    .options-container {
      .option {
        width: 33%;
        display: flex;
        flex-direction: column;
        &.season-container {
          position: relative;
        }
        select {
          -webkit-appearance: none;
          border: 1px solid #ccc;
          height: 36px;
          background-color: #fff;
          background-image: linear-gradient(to top, #f9f9f9, #fff 33%);
          margin: 1rem 0;
          color: #333;
          background-color: #fff;
          border-radius: 1.5rem;
          min-height: 36px;
          align-items: center;
          font-weight: 400;
          font-size: 0.8em;
        }
        #date-pop-up {
          display: none;
          position: fixed;
          background: #fff;
          width: 80vw;
          height: 40vh;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          border: 1px solid black;
          &.active {
            display: block;
          }
        }
      }
    }
  }
  .description {
    width: 90%;
    margin: 2rem auto;
    font-size: 14px;
    a {
      color: blue;
      text-decoration: underline;
    }
  }
  .chart-container {
    width: 90vw;
    height: 600px;
    margin: auto;
    &.players {
      height: 5000px;
    }
    canvas {
      height: 5000px;
    }
  }
  @media only screen and (min-width: 867px) {
    .header {
      .options-container {
        .option {
          select {
            font-size: 1em;
          }
        }
      }
    }
    .header .options-container .option #date-pop-up {
      width: 400px;
      height: 400px;
    }

    .chart-container {
      width: 90%;
      &.players {
        height: 8000px;
      }
    }
  }
`;
